export const GET_TEAMS_SUCCESS = 'GET_TEAMS_SUCCESS';
export const UPDATE_TEAM_SUCCESS = 'UPDATE_TEAM_SUCCESS';
export const ADD_TEAM_SUCCESS = 'ADD_TEAM_SUCCESS';
export const DELETE_TEAM_SUCCESS = 'DELETE_TEAM_SUCCESS';
export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SET_FETCHING_TEAMS = 'SET_FETCHING_TEAMS';